import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import img_titulo from '../../assets/imgs_inauguracao/IMG_ABRE_INAUGURACAO.png';
import img_next from '../../assets/imgs_inauguracao/IMG_NEXT_INAUGURACAO.png';
import seta from '../../assets/imgs_inauguracao/ARROW.png';

// Importando imagens dinamicamente
const importImages = async () => {
  const images = {};
  for (let i = 1; i <= 9; i++) {
        images[`img_${i}`] = require(`../../assets/imgs_inauguracao/IMG_${i}_INAUGURACAO.png`);
  }
  return images;
};

export default function Inauguracao() {

    // Força rolagem para o topo ao carregar o componente
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    const [images, setImages] = useState({});
    
    useEffect(() => {
        importImages().then(setImages);
      }, []);

      useEffect(() => {
        const loadImages = async () => {
            const imgs = await importImages();
            setImages(imgs);
        };

        loadImages();
    }, []);

    const navigate = useNavigate();
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [nextText, setNextText] = useState("PRÓXIMO CONTEÚDO");

    const handleTransition = () => {
        setNextText("");
        setIsTransitioning(true);
        setTimeout(() => {
            navigate('/constituicoes/1824'); 
        }, 1000); 
    }

  return (
    <div className="w-full bg-white flex flex-col justify-center font-medium font-['Lato']">
      <Header cor='branca' />

      <div 
          class="w-full h-auto bg-cover bg-center bg-fixed"
          style={{ backgroundImage: `url(${img_titulo})` }}
      >
        {/* OVERLAY */}
        <div className="w-full h-screen flex flex-col justify-center pt-64 gap-64 pl-24 pr-[33.19vw] pb-28 bg-black/40">
            <div class="w-[56.11vw]">
              <div className="w-[56.11vw] flex-col justify-center items-start inline-flex">
                  <div className="w-[37.56vw] text-white text-3xl font-light font-lato">O PALÁCIO DO CONGRESSO NACIONAL</div>
                  <div className="w-[56.11vw] h-10 text-white text-[45px] font-bold font-futura-bold">INAUGURAÇÃO</div>
              </div>

              <div class="w-[28.58vw] pt-6">
                <div class="pb-1 text-white text-xl font-medium font-['Lato']">Marcos Magalhães</div>
                <div class="w-[28.58vw] h-[0px] border border-white"></div>
                <div class="text-white text-base font-light font-['Lato']">Historiador e Consultor Legislativo</div>
              </div>
            </div>

            <div class="w-[34.7vw] flex justify-end ml-[48vw]"> 
              <div className="w-[21.54vw] text-right text-white text-base font-medium font-['Lato'] [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">Foto do Congresso na noite de inauguração.<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
            </div>
        </div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-start items-end pb-64 pl-40 bg-cover bg-fixed bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_1})`}}
      >
        <div className="w-[27.4vw] text-white text-base font-medium font-['Lato']">Chegada das autoridades civis e militares. JK, João Goulart, Israel Pinheiro, Armando Falcão, Petrônio Portela (óculos escuros) - 21/04/1960.<br/>Acervo Arquivo Público do DF.</div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-end items-start pt-36 pr-24 bg-cover bg-fixed bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_2})`}}
      >
        <div className="w-[23.3vw] text-right text-black text-base font-medium font-['Lato']">Multidão reunida para discurso de JK durante a Inauguração de Brasília - 21/04/1960<br/>Acervo do Arquivo Nacional</div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-start items-start pl-24 pt-40 bg-cover bg-fixed bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_3})`}}
      >
        <div className="w-[31.05vw] text-black text-base font-medium font-['Lato']">Desfile de operários na inauguração de Brasília -  21/04/1960<br/>Acervo do Arquivo Nacional</div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-start items-end pl-36 pb-24 bg-cover bg-fixed bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_4})`}}
      >
        <div className="w-[31.05vw] text-white text-base font-medium font-['Lato']">Esquadrilha da fumaça na inauguração de Brasília - 21/04/1960<br/>Acervo Arquivo Nacional</div>
      </div>


      <div
          className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_5})`}}
      >
          {/* OVERLAY */}
          <div className="w-full h-auto flex flex-col py-80 px-56 bg-[#f6f8ee]/90">
            <div className="w-[64.32vw] text-black text-xl font-medium font-['Lato']">
              ”É com emoção que declaro instalados os trabalhos do Congresso Nacional em Brasília, a nova Capital da República. (Palmas). É com esta simples declaração, senhores senadores e senhores deputados, bem que poderíamos considerar, com realce da síntese, num momento em que a eloquência está nos fatos e não  nas palavras (muito bem; palmas), cumprida a nossa missão, não fora o imperativo de fixarmos, embora em poucos tópicos, o nosso testemunho de justiça e apreço, que, sobretudo nesta Casa, pelo valor e responsabilidade de suas opiniões, especialmente neste ato, não devem faltar.
              <br/><br/>Justiça e apreço ao Congresso Nacional (Palmas), que cumprindo todos os seus deveres institucionais mesmo no calor e entrechoque dos debates que constituem a beleza e a razão de ser de sua vida, não se poupou, em horas incontáveis de exaustiva atuação, para elaborar os instrumentos legais que lhe permitem hoje, reforçado o mérito de sua decisão pelas dificuldades transitórias a que se submetem seus integrantes e suas famílias nesta fase de adaptação e transferência, dar cumprimento a própria deliberação de efetivar a mudança na data fixada pela lei. (Palmas)”.<br/><br/>João Goulart, Vice-Presidente da República e Presidente do Senado e do Congresso Nacional, sessão solene de instalação do Congresso Nacional em Brasília, 21 de abril de 1960</div>
            </div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-start items-end pl-36 pb-12 bg-cover bg-fixed bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_5})`}}
      >
        <div className="w-[31.05vw] text-black text-base font-medium font-['Lato']">Vice-presidente João Goulart - 21/04/1960<br/>Acervo Arquivo Nacional</div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-start items-center pt-12 pl-44 bg-cover bg-fixed bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_6})`}}
      >
        <div className="w-[22.85vw] text-white text-base font-medium font-['Lato']">Plenário na sessão solene de instalação do Congresso Nacional em Brasília - 21/04/1960<br/>Acervo Arquivo Nacional</div>
      </div>

      <div
          className="w-full h-auto flex justify-center items-center relative bg-cover bg-center bg-fixed bg-no-repeat"
          style={{ backgroundImage: `url(${images.img_7})`}}
      >
          {/* OVERLAY */}
          <div className="w-full h-auto flex flex-col py-96 px-56 bg-[#5a6e64]/80">
            <div className="w-[64.32vw] text-white text-xl font-medium font-['Lato']">
              “Ao ensaiar os primeiros passos para cumprir o imperativo constitucional, contou Vossa Excelência (Presidente Juscelino Kubitschek) com ampla e entusiástica cooperação dos líderes das bancadas que o apoiavam e apóiam no Congresso. 
              E não só essas bancadas, mas a quase totalidade dos representantes do povo brasileiro no Parlamento Nacional se empolgou pela grande idéia, não regateando sua colaboração no sentido de armar o Poder Executivo de leis e recursos necessários à execução da obra gigantesca”. <br/><br/>Filinto Müller, Vice-Presidente do Senado, sessão solene de instalação do Congresso Nacional em Brasília, 21 de abril de 1960</div>
            </div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-end items-start pr-24 pt-80 bg-cover bg-fixed bg-center"
          style={{ backgroundImage: `url(${images.img_7})`}}
      >
        <div className="w-[22.85vw] text-right text-white text-base font-medium font-['Lato']">JK e João Goulart na sessão solene de instalação do Congresso Nacional em Brasília - 21/04/1960<br/>Acervo do Arquivo Nacional</div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-start items-start pl-40 pt-24 bg-cover bg-fixed bg-center"
          style={{ backgroundImage: `url(${images.img_8})`}}
      >
        <div className="w-[21.54vw] text-black text-base font-medium font-['Lato']">Autoridades no Congresso e Palácio do Planalto durante os festejos de inauguração<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
      </div>

      <div 
          class="w-full min-h-screen flex justify-end items-start pr-40 pt-36 bg-cover bg-fixed bg-center"
          style={{ backgroundImage: `url(${images.img_9})`}}
      >
        <div className="w-[23.04vw] text-right text-white text-base font-medium font-['Lato']">Foto do prédio do Congresso durante a inauguração, com o 1º Regimento de Cavalaria de Guardas (Dragões da Independência) em primeiro plano. No detalhe a cascata do alto do prédio<br/>Jesco von Puttkamer<br/>UCG/IGPA<br/></div>
      </div>

      <div 
          class="w-full h-auto flex items-center bg-cover bg-center transition-all duration-1000"
          style={{ backgroundImage: `url(${img_next})` }}
      >
          {/* OVERLAY */}
          <div 
              class={`w-full h-screen pl-[7vw] pr-[33.19vw] pt-[45.90vh] pb-[45.80vh] transition-all duration-1000 ${
                  isTransitioning ? 'bg-black/40' : 'bg-[#abb5b0]/70'
              }`}
          >
              <div class="flex gap-6">
                  <div class="flex-col justify-center items-start inline-flex">

                      <div
                          className={`text-3xl font-light font-['Lato'] transition-colors duration-1000 ${
                              isTransitioning ? 'text-white' : 'text-black'
                          }`}
                      >
                          {nextText}
                      </div>
                      <div
                          className={`text-[45px] font-bold font-['Futura Std'] transition-colors duration-1000 ${
                              isTransitioning ? 'text-white' : 'text-black'
                          }`}
                      >
                          A CONSTITUIÇÃO DE 1824
                      </div>
                  </div>
                  <img 
                      class="w-9 h-5 ml-6 mt-auto mb-6 cursor-pointer animate-moveRight transition-transform duration-500 hover:scale-110" 
                      src={seta} 
                      alt='seta'
                      onClick={handleTransition}
                      />
              </div>
          </div>
      </div>
    </div>
  );
}
